module.exports = __webpack_public_path__ + "static/milestonesmain-6fa8f6a4509921f195535c361a3b6dd2.png";